import $ from 'jquery'

$(document).ready(co_vc_template_element())

function co_vc_template_element() {}
